export interface ApiErrorBody {
    title?: string;
    detail?: string;
    type?: string;
}

export async function apiErrorBody(err: Error): Promise<ApiErrorBody> {
    const { response } = err as unknown as { response?: Response };
    let body: ApiErrorBody;
    try {
        body = response ? (JSON.parse(await response.text()) as ApiErrorBody) : {};
    } catch (e) {
        body = {};
    }
    return body;
}
